import React from 'react';
import loader from "../../assets/loader.gif"
import filterLoader from "../../assets/filterLoader.gif"

const FilterLoader = () => {
  return (
    <div
      className={`flex justify-center items-center`}
    >
      <img src={loader} alt={''} width={100} />
    </div>
  );
};

export default FilterLoader;
